<template>
    <div class="categories__tabs">
        <ul class="categories__nav">
            <li v-for="(tab, t) in tabs"><a :class="{ 'active' : t == selected }" @click="selected = t">{{tab.Title}}</a></li>
        </ul>
        <select class="select" v-model="selected">
            <option v-for="(tab, t) in tabs" :value="t">{{tab.Title}}</option>
        </select>
        <div class="categories__wrapper">
            <div class="categories__tab" v-for="(tab, t) in tabs" :class="{ 'active' : t == selected }">
                <component :is="tab.Type" :model="tab"></component>
            </div>
        </div>
    </div>
</template>
<script>
    import ImageLinksGrid from './imageLinksGrid'
    import GettingHereGrid from './gettingHereGrid'
    export default {
        components: {
            ImageLinksGrid,
            GettingHereGrid
        },
        data() {
            return {
                tabs: [],
                selected: 0
            }
        },
        updated() {
            window.lazyLoad.update()
        },
        methods: {
        },
        mounted() {
            var vm = this
            vm.doPost('/umbraco/surface/vue/homegrid', null, (data) => {
                vm.tabs = data
            })
        }
    }
</script>